import { LogoMark } from "@/components/Navbar";
import { scrollToSection } from "@/data/site";

const FOOTER_LINKS = [
  { label: "Cara Kerja", target: "#cara-kerja" },
  { label: "Semua Hadiah", target: "#semua-hadiah" },
  { label: "Rebate untuk Kamu", target: "#rebate" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0D111A]">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
          <div className="flex items-center gap-2.5">
            <LogoMark className="h-8 w-8" />
            <span className="font-display text-base font-bold uppercase text-white">
              Trade <span className="text-[#F0B429]">&</span> Claim
              <span className="ml-1.5 font-sans text-xs font-medium text-zinc-500">
                × Self Rebate
              </span>
            </span>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {FOOTER_LINKS.map((l) => (
              <button
                key={l.target}
                onClick={() => scrollToSection(l.target)}
                className="text-xs font-medium text-zinc-500 transition-colors hover:text-white sm:text-sm"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-8 border-t border-white/5 pt-6 text-center">
          <p className="text-xs leading-relaxed text-zinc-500 sm:text-sm">
            Trading mengandung risiko kerugian. Rebate dan hadiah berlaku
            sesuai syarat dan ketentuan program.
          </p>
          <p className="mt-2 text-[11px] text-zinc-600">
            © 2026 Trade & Claim × Self Rebate. Rebate US$15 per lot — klaim
            melalui admin.
          </p>
        </div>
      </div>
    </footer>
  );
}
